export default "__VITE_PUBLIC_ASSET__43fe95bb__"